import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Dialog } from '@dojo/widgets/dialog';
import Button from '@dojo/widgets/button';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { createNlsMiddleware, registry, landingChange, documentapi } from 'lcc-state';
import { ResourceParser } from '@holmescorp/resource-parser';
import { publish } from '@holmescorp/pub-sub';

import css from '../css/general.m.css';

export interface SurveyProperties {
	useDialog: boolean;
	useResourceParsing: boolean;
}

const nls = createNlsMiddleware('landing');
const factory = create({
	theme,
	nls,
	documentapi
}).properties<SurveyProperties>();

export const GeneralLandingPage = factory(({ properties, middleware: { theme, nls, documentapi } }) => {
	const { useDialog = false, useResourceParsing = true } = properties();
	const themeCss = theme.classes(css);

	const {
		messages: {
			general_content = '[]',
			general_complete_button = 'Continue',
			general_a11y_description = '[landing] general_a11y_descriotion'
		}
	} = nls();

	const markComplete = () => {
		landingChange({ complete: true });
		publish('active-view', 'assess');
	};

	const button = w(
		Button,
		{
			onClick: markComplete
		},
		[{ label: general_complete_button }]
	);

	const content = v('div', { classes: [themeCss.root] }, [
		useResourceParsing
			? w(ResourceParser, { topicid: 'general_content', messages: { default: general_content } })
			: v('div', { innerHTML: general_content }),
		useDialog ? null : button
	]);

	documentapi.setTitle(general_a11y_description);

	return useDialog
		? w(Dialog, { open: true, underlay: true, closeable: true, onRequestClose: markComplete }, [{ content }])
		: content;
});

registry.define('LandingPageGeneral', GeneralLandingPage);
export default GeneralLandingPage;
